'use client';

import React, { Suspense } from 'react';
import { Example } from '@/types/Example';
import PrintButton from './PrintButton';
import CheatsheetViewSelector from './CheatsheetViewSelector';
import FilterSelector from './FilterSelector';
import CommandCatalogue from './CommandCatalogue';
import CheatsheetClient from './CheatsheetClient';

interface CheatsheetAreaProps {
  cheats: Example[];
}

const CheatsheetArea = (props: CheatsheetAreaProps) => {
  const { cheats } = props;

  return (
    <div className="w-full max-w-5xl print:max-w-full">
      <Suspense fallback={<div className="flex-1" />}>
        <div className="bg-background mb-8 flex w-full justify-between rounded print:hidden">
          <CheatsheetViewSelector className="hidden sm:flex" />
          <FilterSelector className="text-center" />
          <PrintButton className="hidden justify-end sm:flex" />
        </div>
      </Suspense>
      <Suspense
        fallback={
          <CommandCatalogue
            cheats={cheats}
            showAsGrid={false}
            showDifficulty
            editable
          />
        }
      >
        <CheatsheetClient
          cheats={cheats}
          showAsGrid={false}
          showDifficulty
          editable
        />
      </Suspense>
    </div>
  );
};

export default CheatsheetArea;
